/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable react/jsx-no-useless-fragment -- needed */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { getSelectedProduct } from '@americanexpress/product-ducks';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { Selectors } from '@americanexpress/axp-benefits-utils';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Contentsquare } from '@americanexpress/shared-scripts';
import { FetchyeProvider } from 'fetchye';
import { fromJS } from 'immutable';
import { IntlProvider } from 'react-intl';
import routes from './routes';
import { Loading } from './new/shared/components/loading';
import { ModuleID } from './constants';
import { loadModuleData } from './new/view-all/ducks/loader';
import reducer from './new/view-all/ducks';
import { flattenMessages } from './utilities/flatten-messages';
import WrapperViewAll from './pages/view-all';
import WrapperDetails from './pages/details';

export function Benefitsviewall(props) {
  const children = props?.children;
  const isLoading = props?.moduleState?.loader?.isLoading;
  const cardDetails = props?.cardDetails;
  const languageData = props?.languageData;

  const flatLanguageData = flattenMessages(languageData);
  const childElements = React.Children.map(children, (child) => React.cloneElement(child, {
    cardDetails,
  })
  );

  const dispatch = useDispatch();
  const activeLocale = useSelector((state) => state.getIn(['intl', 'activeLocale']));
  useEffect(() => {
    dispatch(loadLanguagePack('axp-benefits-view-all', { fallbackLocale: 'en-US' }));
  }, [activeLocale]);

  return (
    <>
      {global.BROWSER && (
        <>
          <Contentsquare version="^1.0.2" />
          <FetchyeProvider>
            {
              isLoading
                ? <Loading />
                : (
                  <IntlProvider locale={props?.languageData?.locale || props?.locale} messages={flatLanguageData} defaultLocale="en-US">
                    { childElements }

                    {/* Demo Routes Set-up */}
                    {/* Sample URL: http://localhost:3000/demo/wrapped/axp-benefits-view-all?props={"benname":"airline-fee-credit","cardname":"platinum"} */}
                    {
                      window?.location?.href.includes('demo')
                      && (
                        <>
                          {props?.benname ? <WrapperDetails params={{ benname: props?.benname, cardname: props?.cardname }} />
                            : <WrapperViewAll params={{ cardname: props?.cardname }} location={props?.location} /> }
                        </>
                      )
                    }
                  </IntlProvider>
                )
            }
          </FetchyeProvider>
        </>
      )}
    </>
  );
}

Benefitsviewall.propTypes = {
  moduleState: PropTypes.shape({
    loader: PropTypes.shape({
      isLoading: PropTypes.bool,
    }),
  }).isRequired,
};

export function mapStateToProps(state) {
  return {
    cardNameState: Selectors.getCardNameFromState(state),
    accountToken: getSelectedProduct(state),
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
  };
}

export function shouldModuleReload(currentProperties, nextProperties) {
  return currentProperties.locale !== nextProperties.locale;
}

// connect function will add the 'dispatch' property to your components
const hocChain = compose(
  oneAppModuleWrapper(ModuleID),
  connect(mapStateToProps, null)
);

Benefitsviewall.holocron = {
  name: ModuleID,
  loadModuleData,
  shouldModuleReload,
  reducer,
};

Benefitsviewall.childRoutes = routes;

export default hocChain(Benefitsviewall);
